import { Button, Grid, Typography } from "@material-ui/core";
import useText from "constants/text";
import React from "react";
import { useStyles } from "./styles";


interface IProps {
    onPrev?: React.Dispatch<React.SetStateAction<number>>;
  }
export default function ErrorMessage({onPrev}: IProps) {
  const {text} = useText();
  const styles = useStyles();

  const handleBackWebSite = () => {
    window.location.replace("https://papslogistics.com/");
  };
  return (
    <Grid
      container
      spacing={2}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Grid xs={12} item style={{ width: "60%" }}>
        <Typography variant="h2" align="center">
          {text.all.account_already}
        </Typography>
      </Grid>
      <Grid xs={12} item>
        <Button className={styles.back} onClick={handleBackWebSite}>
          {text.all.return_to_the_website}
        </Button>
      </Grid>
    </Grid>
  );
}


